import { css, keyframes } from '@emotion/core';
import { Animation, Colors, Shadows, Zindexes, } from '@zapier/design-system/dist/theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/common-utils';
import { useClickOutside, useIntersect } from '@zapier/design-system/dist/hooks';
const menuOpenAnimation = keyframes({
    '0%': {
        transform: 'translateY(-10px)',
        opacity: 0,
    },
    '30%': {
        transform: 'translateY(-10px)',
        opacity: 0,
    },
    '100%': {
        transform: 'translateY(0)',
        opacity: 1,
    },
});
const DISTANCE = 'calc(100% + 5px)';
const Styles = labelStyles(__filename, {
    root: (props, derivedState) => [
        css({
            animation: `${Animation.transitionDuration} ease-out ${menuOpenAnimation}`,
            maxWidth: props.maxWidth,
            position: 'absolute',
            minWidth: props.minWidth,
            zIndex: Zindexes.dropdownMenu,
        }),
        props.align === 'left' &&
            withModifier(props.align, {
                left: 0,
            }),
        props.align === 'right' &&
            withModifier(props.align, {
                right: 0,
            }),
        props.align === 'stretch' &&
            withModifier(props.align, {
                left: 0,
                right: 0,
            }),
        derivedState.position === 'south' &&
            withModifier(derivedState.position, {
                top: DISTANCE,
            }),
        derivedState.position === 'north' &&
            withModifier(derivedState.position, {
                bottom: DISTANCE,
            }),
    ],
    box: css({
        backgroundColor: Colors.white,
        border: `1px solid ${Colors.grey200}`,
        borderRadius: 10,
        boxShadow: Shadows.elevation20,
    }),
});
export const FloatingBox = (props) => {
    const threshold = 0.9;
    const [setIntersectNode, { isBottomIntersecting, isTopIntersecting },] = useIntersect({
        heightOverride: props.intersectHeight,
        once: true,
        threshold,
    });
    const onClickOutside = props.onClickOutside || (() => { });
    const [setClickOutsideNode] = useClickOutside({
        onClickOutside,
    });
    const setNode = (node) => {
        setIntersectNode(node);
        setClickOutsideNode(node);
    };
    const derivedState = {
        position: props.position ||
            (isTopIntersecting || !isBottomIntersecting ? 'south' : 'north'),
    };
    return (isolateComponent("div", { css: Styles.root(props, derivedState), ref: setNode },
        isolateComponent("div", { css: Styles.box }, props.children)));
};
FloatingBox.defaultProps = {
    align: 'left',
};
//# sourceMappingURL=FloatingBox.js.map
